import { render, staticRenderFns } from "./ModalModeloDocumentoRevisao.vue?vue&type=template&id=3e8d3a65&scoped=true"
import script from "./ModalModeloDocumentoRevisao.vue?vue&type=script&lang=js"
export * from "./ModalModeloDocumentoRevisao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8d3a65",
  null
  
)

export default component.exports